import { Transaction } from "@cede/types";
import { compareCefiTx } from "./compare";

/**
 * @description Removes duplicate transactions from the base list
 *
 * @param baseList - txs to filter
 * @param txsToRemove - txs to remove from the base list
 * @returns
 */
export function substractTxsFromBaseList(baseList: Transaction[], txsToRemove: Transaction[]) {
  if (!txsToRemove) return baseList;
  return baseList.filter((tx) => !txsToRemove.find((cachedTx) => compareCefiTx(tx, cachedTx)));
}
